import classNames from 'classnames';
import { getActivityStatus } from 'utils';
import { convertDateToTimeZone, DateFormatter } from 'infrastructure/functions';
import { DateFormats } from 'infrastructure/enums';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';
import { useTranslation } from 'react-i18next';
import { isCHFReading } from 'utils/get-reading-info';

import s from './styles.module.scss';
import CHFRenalStatus from '../chf-renal-status';

import type { Nullable } from 'infrastructure/types';
import type {
  TMightBeErroneousReason,
  TThresholdName,
} from 'infrastructure/interfaces/i-rpm-patient-activity';
import type { IPatientThresholds } from 'infrastructure/interfaces';
import type { FC, ReactNode } from 'react';
import type { ReadingStatus } from 'infrastructure/enums/reading-statuses';

interface DateColumnMobileProps {
  globalStatus: ReadingStatus;
  idx: number;
  createdAt: string;
  timezone: string;
  children?: ReactNode;
  thresholdName?: Nullable<TThresholdName>;
  thresholds: IPatientThresholds;
  mightBeErroneousReason?: TMightBeErroneousReason;
}

const DateColumnMobile: FC<DateColumnMobileProps> = ({
  globalStatus,
  idx,
  createdAt,
  timezone,
  children,
  thresholdName,
  thresholds,
  mightBeErroneousReason,
}) => {
  const { t } = useTranslation();
  const location = useLocation();
  const { slaReadings } = queryString.parse(location.search);

  const status = slaReadings === 'true' ? 'slaReading' : globalStatus;
  const isCHF = isCHFReading(thresholdName);

  return (
    <div className={s['date-cell']}>
      <div className={classNames(s['date-wrapper-mob'])}>
        <div>
          <p className={classNames(s[`status-${status}`], s.status)}>
            {getActivityStatus(status)}
          </p>
          {thresholdName && isCHF && (
            <CHFRenalStatus
              thresholdName={thresholdName}
              thresholds={thresholds}
              mightBeErroneousReason={mightBeErroneousReason}
            />
          )}
        </div>
        <p className={s['item-number']}>#{idx}</p>
        <p data-cy="reading-date" className={s.date}>
          {DateFormatter({
            date: new Date(parseInt(createdAt)),
            format: DateFormats['MM-dd-yyyy hh:mm:ss a'],
          })}
          <br />
          <span className={s.label}>{t('labels.patientTimezone')}</span>
          <br />
          {DateFormatter({
            date: convertDateToTimeZone(
              new Date(parseInt(createdAt)),
              timezone,
            ),
            format: DateFormats['MM-dd-yyyy hh:mm:ss a'],
          })}
          <br />
        </p>
        {children}
      </div>
    </div>
  );
};
export default DateColumnMobile;
